export default {
  autocompleteContainer: {
    position: 'relative',
    width: '100%',
    maxWidth: '30em',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
    '& input': {
      width: '100%',
      boxSizing: 'border-box',
      padding: '5px'
    },
    '& .adressevaelger-suggestions': {
      margin: '0.3em 0 0 0',
      padding: 0,
      textAlign: 'left',
      listStyle: 'none',
      borderRadius: '0.3125em',
      background: '#fcfcfc',
      boxShadow: '0 0.0625em 0.15625em rgba(0, 0, 0, 0.15)',
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      zIndex: 9999,
      overflowY: 'auto',
      maxHeight: '50vh',
      boxSizing: 'border-box'
    },
    '& .adressevaelger-suggestions .adressevaelger-suggestion': {
      margin: 0,
      listStyle: 'none',
      cursor: 'pointer',
      padding: '0.4em 0.6em',
      color: '#333',
      border: '0.0625em solid #ddd',
      borderBottomWidth: 0
    },
    '& .adressevaelger-suggestions .adressevaelger-suggestion:first-child': {
      borderTopLeftRadius: 'inherit',
      borderTopRightRadius: 'inherit'
    },
    '& .adressevaelger-suggestions .adressevaelger-suggestion:last-child': {
      borderBottomLeftRadius: 'inherit',
      borderBottomRightRadius: 'inherit',
      borderBottomWidth: '0.0625em'
    },
    '& .adressevaelger-suggestions .adressevaelger-suggestion.dawa-selected, & .adressevaelger-suggestions .adressevaelger-suggestion:hover': {
      background: '#f0f0f0'
    }
  },
  hidden: {
    visibility: 'hidden'
  }
};
